import { Component, ElementRef, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';
import { DataUploadsRoutes, DataUploadsRoutesStates } from '../../shared/constants/data-uploads-routes.constant';
import { UtilitiesService } from '../../shared/services/utilities/utilities.service';
import { IDataLoad } from '../../shared/typings/interfaces/data-load.interface';
import { ICollegePath } from '../../shared/typings/interfaces/paths.interface';
import { ISchool } from '../../shared/typings/interfaces/school.interface';
import { IStudentPath } from '../../shared/typings/interfaces/studentPaths.interface';
import { IUser } from '../../shared/typings/interfaces/user.interface';
import { IStudent } from '../../store/reducers/student-reducer';
import { ImSchool } from 'Src/ng2/shared/services/im-models/im-school';

@Component({
  selector: 'nv-data-uploads',
  template: require('./data-uploads.component.html'),
  styles: [require('./data-uploads.component.scss')],
})
export class DataUploadsComponent implements OnInit {
  @Input() currentUser: IUser;
  @Input() currentRoute: string;
  @Input() currentSchool: ISchool;
  @Input() studentPaths$: Observable<IStudentPath[]>;
  @Input() collegePaths$: Observable<ICollegePath[]>;
  @Input() students$: Observable<IStudent[]>;
  @Input() dataLoads$: Observable<IDataLoad[]>;

  public DataUploadsRoutes = DataUploadsRoutes;
  public schoolId: string;
  public isHS: boolean;

  constructor(@Inject('$state') private $state, private imSchool: ImSchool) {
    //
  }

  ngOnInit() {
    this.schoolId = this.currentSchool._id;
    this.isHS = this.imSchool.isHighSchool(this.currentSchool);
  }

  public changeView(route: string): void {
    if (route !== this.currentRoute) {
      this.$state.go(DataUploadsRoutesStates[route]);
    }
  }

  public back(): void {
    this.$state.go('main.school.home', { schoolId: this.schoolId });
  }
}
